const address = `
    apartmentNumber
    city
    country
    district
    firstName
    houseNumber
    id
    lastName
    postalCode
    streetName
`;

export default address;
